import type { ActionId, ActionSurface } from './action'

export type ActionTelemetryRecord = { actionId: ActionId; outcome: string; invokedFrom: ActionSurface; correlationId: string }
type LogEvent = (name: string, parameters: ActionTelemetryRecord) => void

// Telemetry must never make action execution unavailable. A later analytics
// integration can provide Firebase's logEvent (or another provider) here.
let logEvent: LogEvent | undefined

export const setActionTelemetryLogger = (logger: LogEvent | undefined): void => { logEvent = logger }
export const record = (event: ActionTelemetryRecord): void => { logEvent?.('action_invoked', event) }
